import Image from 'next/image';
import React, { useContext } from 'react';

import { Context } from '../../contexts/AppContext';
import ROUTES from '../../routes';
import Container from '../Container';

import { loaderProp } from '@utils/random';

const LearnSideCTA = ({
  className,
  image = `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/images/cta.svg`,
  title = 'Ready for a modern SQL editor?',
  cta = {
    text: 'Get started for free',
    href: `${process.env.NEXT_PUBLIC_WEB_HOST}/users/sign_up`,
  },
  ctaLoggedIn = {
    text: 'Get PopSQL',
    href: ROUTES.download,
  },
  description,
  withImage = true,
}) => {
  const { isLoggedIn } = useContext(Context);

  return (
    <Container
      singleColumn
      className={`sticky top-24 mb-20 md:mt-16 max-w-screen-xl w-full ${
        className || ''
      }`}
    >
      <div className="sm:w-60 flex flex-wrap items-center bg-white shadow-cta rounded-xl border border-gray-100 relative overflow-hidden py-8">
        <div className={`z-10 w-full px-8 pb-0`}>
          {withImage && (
            <div className={`${image.includes('dbt') ? 'mb-2' : 'mb-4'}`}>
              <Image
                src={image}
                alt="database icon"
                height="40"
                width="40"
                loader={loaderProp}
              />
            </div>
          )}
          <div className="mb-3 font-bold font-display tracking-tightest text-black text-xl leading-6">
            {title}
          </div>
          {description && (
            <div className="mb-6 text-xs text-gray-600 font-inter font-medium">
              {description}
            </div>
          )}

          <div className="mb-4">
            <a
              href={isLoggedIn ? ctaLoggedIn.href : cta.href}
              className="flex items-center justify-center my-2 cursor-pointer text-center bg-primary text-white py-3 px-3 rounded-md text-xs font-inter font-semibold hover:shadow-lg focus:shadow-lg focus:outline-none focus:opacity-80 transition duration-100 ease"
            >
              {isLoggedIn ? ctaLoggedIn.text : cta.text}
            </a>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default LearnSideCTA;
